import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-finished"]

import { PropType } from "vue";
import { Project } from "@/types";
import ProjectCardProperties from "./ProjectCardProperties.vue";
import ProjectCardTools from "./ProjectCardTools.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCard',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-finished": __props.project.finished && __props.project.projectStatus === 2,
    class: "ProjectCard"
  }, [
    _createVNode(ProjectCardProperties, { project: __props.project }, null, 8, ["project"]),
    _createVNode(ProjectCardTools, { project: __props.project }, null, 8, ["project"])
  ], 8, _hoisted_1))
}
}

})